export const createARubric = `
    mutation createARubric ($programId: String!) {
        createARubric(programId: $programId) {
          alert {
            message
          }
          key
          label
          status
          items {
              isEnabled
              gradingTemplate
              label
              order
          }
          programId
          programLabel
          updatedDate
  }
}`;


export const archiveRubric = `
  mutation archiveRubric ($programId: String!, $key: String!) {
      archiveRubric(programId: $programId, key: $key) {
          alert {
            message
          }
          programId
          key
          programLabel
      }
}`;

export const deleteRubric = `
  mutation deleteRubric ($programId: String!, $key: String!) {
      deleteRubric(programId: $programId, key: $key) {
          alert {
            message
          }
          programId
          key
      }
}`;

export const getRubricConfig = `
 query getRubricConfig {
    getRubricConfig {
      gradingTemplates
    }
}`

export const saveRubricV2 = `
 mutation saveRubricV2($input: SaveRubricInput!) {
    saveRubricV2(input: $input) {
      alert {
        message
      }
      programId
      key
      updatedDate
      items {
        isEnabled
        gradingTemplate
        label
        order 
      }
  }
}`

export const cloneRubric = `
 mutation cloneRubric($input: CloneRubricInput!) {
    cloneRubric(input: $input) {
      programId
      key
      label
      items {
        isEnabled
        gradingTemplate
        label
        order 
      }
      status
      programLabel
      updatedDate
  }
}`

export const getRubrics = `
 query getRubrics($programId: String!) {
    getRubrics(programId: $programId) {
      key
      label
      status
      items {
        isEnabled
        gradingTemplate
        label
        order
      }
      programId
      programLabel
      updatedDate
    }
}`

export const setActiveRubric = `
 mutation setActiveRubric($programId: String!, $newActiveRubricKey: String!, $prevActiveRubricKey: String) {
    setActiveRubric(programId: $programId, newActiveRubricKey: $newActiveRubricKey, prevActiveRubricKey: $prevActiveRubricKey) {
      key
      status
      programId
      updatedDate
  }
}`